<template>
  <main class="home-main">
    <!-- Main container -->
    <div class="container">
      <!-- Top section with dates and title -->
      <div class="top-section">
        <p class="date-text">DU 01 FÉVRIER AU 06 AVRIL 2026</p>
        <h1 class="grand-jeu-title">GRAND JEU</h1>
        <p class="subtitle-text">Pour l'achat d'un produit Carte Noire</p>
      </div>

      <!-- Content section with 3 columns -->
      <div class="content-section">
        <!-- Left column: À GAGNER + Prizes -->
        <div class="left-column">
          <!-- Banner À GAGNER -->
          <div class="a-gagner-banner">
            <span class="a-gagner-text">À GAGNER</span>
          </div>

          <!-- Prizes -->
          <div class="prizes-list">
            <!-- Maillots -->
            <div class="prize-row prize-row-maillot">
              <div class="prize-info">
                <p class="prize-title">50 MAILLOTS<sup>(1)</sup><br/>OFFICIELS</p>
                <p class="prize-subtitle">de l'équipe de France<br/>de Rugby</p>
              </div>
              <img src="@/assets/img/Maillot.png" alt="Maillot" class="maillot-img" />
            </div>

            <!-- Tasses -->
            <div class="prize-row prize-row-tasse">
              <img src="@/assets/img/Tasse_1.png" alt="Tasse" class="tasse-img" />
              <div class="prize-info">
                <p class="prize-title">200 GRANDES<br/>TASSES</p>
              </div>
            </div>

            <!-- Codes promos -->
            <div class="prize-info prize-codes">
              <p class="prize-title">ET DES CODES PROMOS<sup>(2)</sup></p>
              <p class="prize-subtitle">à valoir sur cartenoire.fr</p>
            </div>
          </div>
        </div>

        <!-- Center column: Coffee bean + CTA -->
        <div class="center-column">
          <!-- Coffee bean image -->
          <div class="bean-container">
            <img 
              src="@/assets/img/graine+poteau.png" 
              alt="Grain de café" 
              class="bean-image"
            />
          </div>
          <div class="cta-wrapper">
            <router-link to="/form" class="cta-button">JE PARTICIPE</router-link>
          </div>
        </div>

        <!-- Right column: How to participate -->
        <div class="right-column">
          <h2 class="participate-title">COMMENT PARTICIPER ?</h2>
          
          <div class="steps-list">
            <div class="step-item">
              <div class="step-circle">1</div>
              <p class="step-main-text"><strong>Achetez un produit Carte Noire</strong></p>
              <p class="step-sub-text">en conservant votre preuve d'achat</p>
            </div>

            <div class="step-item">
              <div class="step-circle">2</div>
              <p class="step-main-text"><strong>Remplissez le formulaire</strong> et</p>
              <p class="step-sub-text">téléchargez votre preuve d'achat</p>
            </div>

            <div class="step-item">
              <div class="step-circle">3</div>
              <p class="step-sub-text">Découvrez ce que vous avez</p>
              <p class="step-main-text"><strong>gagné</strong></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile CTA button -->
      <div class="mobile-cta-wrapper">
        <router-link to="/form" class="cta-button">JE PARTICIPE</router-link>
      </div>

      <!-- Bottom legal text -->
      <div class="legal-section">
        <p class="legal-text">
          (1) 30 de taille L et 20 de taille M disponibles, distribués aléatoirement (2) Utilisables une fois sur tout le site cartenoire.fr (-5€ à partir de 50€ d'achat), valables jusqu'au 31/12/2026.
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
.home-main {
  background-color: #000;
  color: white;
  position: relative;
  min-height: calc(100vh - 150px - 60px);
  padding-top: 60px;
  padding-bottom: 20px;
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 5vw, 60px);
  position: relative;
  z-index: 10;
}

/* Bean container - in center column */
.bean-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
  flex: 1;
  overflow: visible;
}

.bean-image {
  width: 180%;
  max-width: none;
  height: auto;
  min-height: 450px;
  object-fit: contain;
  margin-top: -30px;
  margin-left: -40%;
  margin-right: -40%;
}

/* Top Section */
.top-section {
  text-align: center;
  margin-bottom: 15px;
}

.date-text {
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: clamp(12px, 2vw, 16px);
  letter-spacing: 0.25em;
  margin-bottom: 10px;
  color: white;
}

.grand-jeu-title {
  font-family: var(--font-primary);
  font-size: clamp(50px, 10vw, 93px);
  font-weight: 700;
  line-height: 0.85;
  margin: 0;
  color: white;
  letter-spacing: 0.02em;
}

.subtitle-text {
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: clamp(14px, 2.5vw, 20px);
  margin-top: 15px;
  color: white;
}

/* Content Section - 3 columns */
.content-section {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  gap: 40px;
  align-items: start;
}

/* Left Column */
.left-column {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* À GAGNER Banner */
.a-gagner-banner {
  background-color: #000;
  border: 3px solid #fff;
  padding: clamp(10px, 2vw, 14px) clamp(20px, 3vw, 28px);
  display: inline-block;
  align-self: flex-start;
}

.a-gagner-text {
  font-family: var(--font-primary);
  font-weight: 900;
  font-size: clamp(24px, 4vw, 32px);
  color: white;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

/* Prizes List */
.prizes-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prize-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.prize-info {
  text-align: left;
}

.prize-title {
  font-family: var(--font-primary);
  font-weight: 800;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.2;
  margin: 0;
  color: white;
}

.prize-subtitle {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: clamp(14px, 1.8vw, 18px);
  color: #ccc;
  margin: 5px 0 0 0;
}

.maillot-img {
  height: clamp(80px, 12vw, 120px);
  object-fit: contain;
}

.tasse-img {
  height: clamp(65px, 10vw, 95px);
  object-fit: contain;
}

/* Center Column */
.center-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  overflow: visible;
  position: relative;
  z-index: 1;
}

.cta-wrapper {
  margin-top: -20px;
  position: relative;
  z-index: 10;
}

/* Mobile CTA - hidden on desktop */
.mobile-cta-wrapper {
  display: none;
}

.cta-button {
  display: inline-block;
  background-color: white;
  color: black;
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: clamp(16px, 2vw, 20px);
  padding: clamp(14px, 2vw, 18px) clamp(40px, 6vw, 65px);
  border-radius: 50px;
  text-decoration: none;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background-color: #f0f0f0;
  transform: scale(1.02);
}

/* Right Column */
.right-column {
  display: flex;
  flex-direction: column;
}

.participate-title {
  font-family: var(--font-primary);
  font-weight: 900;
  font-size: clamp(20px, 3vw, 30px);
  text-align: center;
  margin-bottom: 25px;
  color: white;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-item {
  text-align: center;
}

.step-circle {
  width: clamp(28px, 4vw, 36px);
  height: clamp(28px, 4vw, 36px);
  background-color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-primary);
  font-weight: 900;
  font-size: clamp(12px, 1.5vw, 16px);
  color: #000;
  margin-bottom: 8px;
}

.step-main-text {
  font-family: var(--font-primary);
  font-weight: 350;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.1;
  margin: 5px 0 0 0;
  color: white;
}

.step-main-text strong {
  font-weight: 700;
}

.step-sub-text {
  font-family: var(--font-primary);
  font-weight: 350;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.1;
  color: white;
  margin: 5px 0 0 0;
}

/* Legal Section */
.legal-section {
  text-align: center;
  margin-top: 25px;
}

.legal-text {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: clamp(10px, 1.5vw, 14px);
  color: #888;
  margin: 0;
  line-height: 1.5;
}

/* ========================================
   LARGE SCREENS (1920px+)
   ======================================== */
@media (min-width: 1920px) {
  .bean-image {
    width: 170%;
    min-height: 520px;
    margin-left: -35%;
    margin-right: -35%;
  }
}

@media (min-width: 2400px) {
  .bean-image {
    width: 160%;
    min-height: 580px;
    margin-left: -30%;
    margin-right: -30%;
  }
}

/* ========================================
   TABLET BREAKPOINT
   ======================================== */
@media (max-width: 1024px) {
  .content-section {
    grid-template-columns: 1fr 1.3fr 1fr;
    gap: 10px;
  }

  .bean-image {
    width: 200%;
    min-height: 380px;
    margin-left: -50%;
    margin-right: -50%;
  }
}

/* ========================================
   MOBILE BREAKPOINT
   ======================================== */
@media (max-width: 768px) {
  .home-main {
    padding-top: 50px; /* Space for logo overlap */
    min-height: auto;
  }

  .top-section {
    margin-bottom: 10px;
    text-align: center;
  }

  .bean-container {
    width: 100%;
    overflow: visible;
    justify-content: center;
  }

  .bean-image {
    width: 140%;
    max-width: none;
    height: auto;
    max-height: none;
    min-height: 300px;
    object-fit: contain;
    margin-left: -20%;
    margin-right: -20%;
    margin-top: 0;
  }

  /* Stack content in single column */
  .content-section {
    display: flex;
    flex-direction: column;
    gap: 30px;
    min-height: auto;
    align-items: center;
  }

  /* Left column - prizes */
  .left-column {
    order: 2;
    align-items: center;
    gap: 20px;
    width: 100%;
  }

  .a-gagner-banner {
    align-self: center;
  }

  .prizes-list {
    width: 100%;
    gap: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .prize-row {
    justify-content: center;
    width: 100%;
  }

  .prize-info {
    text-align: center;
  }

  .prize-codes {
    text-align: center;
    width: 100%;
  }

  /* Show center column on mobile with bean, hide CTA */
  .center-column {
    display: flex;
    order: 0;
    width: 100%;
    margin-bottom: 20px;
  }

  .center-column .cta-wrapper {
    display: none;
  }

  .center-column .bean-container {
    width: 100%;
  }

  /* Right column - how to participate */
  .right-column {
    order: 3;
    width: 100%;
    align-items: center;
  }

  .participate-title {
    margin-bottom: 20px;
    text-align: center;
  }

  .steps-list {
    gap: 15px;
    align-items: center;
  }

  .step-item {
    text-align: center;
    width: 100%;
  }

  /* Show mobile CTA */
  .mobile-cta-wrapper {
    display: flex;
    justify-content: center;
    margin: 30px 0;
    width: 100%;
  }

  .legal-section {
    margin-top: 20px;
    text-align: center;
  }

  .legal-text {
    text-align: left;
    padding: 0 10px;
  }
}

/* ========================================
   SMALL MOBILE BREAKPOINT
   ======================================== */
@media (max-width: 480px) {
  .bean-image {
    width: 150%;
    max-width: none;
    min-height: 250px;
    margin-left: -25%;
    margin-right: -25%;
  }

  .maillot-img {
    height: 70px;
  }

  .tasse-img {
    height: 55px;
  }

  .cta-button {
    padding: 14px 50px;
  }
}
</style>
